// @flow strict

export default () => window.SpeechRecognition || window.webkitSpeechRecognition;
